<template>
  <div class="container huicai_global_style">
    <div class="head">
      <div class="head__fixed">
        <div class="head__fixed__box">
          <div class="header__fixed__left"><a href="javascript:history.go(-1)" class="back"></a></div>
          <div class="header__fixed__center">
            <h1>开通会员成功</h1>
          </div>
          <div class="header__fixed__right"></div>
        </div>
      </div>
    </div>
    <div class="bb_buycardvip_bg">
      <div class="bb_buycardvip_bg_card">
        <div class="bb_buycardvip_bg_card_newCardStyle">
          <img v-if="vipcardinfo.thumb==null||vipcardinfo.thumb==''" src="../../assets/images/base/fixedCard.png" />
          <img v-else :src="vipcardinfo.thumb" />
          <div class="bb_buycardvip_bg_card_newCardStyle_con">
            <div class="bb_bcd_title">
              &nbsp;
            </div>
            <div class="bb_bcd_cont1">
              {{vipcardinfo.msg_1}}
            </div>
            <div class="bb_bcd_cont2">
              {{vipcardinfo.start_dateM}} - {{vipcardinfo.end_dateM}}
            </div>
          </div>
        </div>
        <div class="bb_buycardvip_bg_tip">
          <!-- 恭喜您加入斐燃会员俱乐部，您已成功开通{{vipcardinfo.name}}会员资格 -->
          您已成功开通斐燃会员，恭喜您加入斐燃会员俱乐部
        </div>
        <div class="bb_buycardvip_bg_btn">
          <div class="bb_buycardvip_bg_btn_left" @click="stp_btn_ordevip()">查看会员</div>
          <div class="bb_buycardvip_bg_btn_right" @click="toreserve()">立即预约</div>
          <div class="clearboth"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default{
    data() {
      return {
        vipcardinfo:{},
      }
    },
    created() {
      // console.log(this.$route.params)
      this.detailByOrderNo(this.$route.params.user_cards_id)
    },
    watch: {},
    mounted() {
    },
    methods: {
      toreserve(){
        this.$router.push({
          name: "reserve"
        })
      },
      detailByOrderNo(usercardid){

        var $this=this
        let param = {
          token:localStorage.getItem("token"),
          user_cards_id: usercardid
        }
        var qs = require('qs');
        let url = this.api.userApi.flCardsDetail
        this.axios.post(url, qs.stringify(param), )
        .then((result) => {
          console.log(result)
          if (result.code == 0) {
            result.data.start_dateM=(result.data.start_date).replace(/-/g,'.')
            result.data.end_dateM=(result.data.end_date).replace(/-/g,'.')
            $this.vipcardinfo=result.data
          }else{
            $this.$toast(result.msg);
          }
        }).catch((error) => {
          console.warn(error)
          // $this.$toast('error');
        })
      },
      stp_btn_ordevip(){
        // this.$router.push({
        //   name: 'vip',
        // })
        this.$router.push({
          name: 'myCardDetail',
          params: {
            id: this.vipcardinfo.id
          }
        })
      },
    },
  }
</script>

<style lang="less" scoped="scoped">
  @vm_base: 1/750*100vw;
  .huicai_global_style{
    width: 100%;
    height: 100vh;
    overflow: hidden;
    overflow-y: auto;
    background: #FFFFFF;
  }
  .bb_buycardvip_bg{
    position: absolute;
    top: 0;
    left: 0;
    width: calc(100% - 64*@vm_base);
    height: 564*@vm_base;
    margin-left: 32*@vm_base;
    margin-top: 250*@vm_base;
    background:rgba(255,255,255,1);
    box-shadow:0px 10*@vm_base 20*@vm_base 0px rgba(238,238,238,1);
    border-radius:12*@vm_base;
    .bb_buycardvip_bg_card{
      position: absolute;
      top: 0;
      left: 0;
      padding: 0 32*@vm_base;
      margin-top: -120*@vm_base;
      .bb_buycardvip_bg_card_newCardStyle{
        width: 100%;
        position: relative;
        img{
          width: 100%;
        }
        .bb_buycardvip_bg_card_newCardStyle_con{
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          padding: 32*@vm_base 34*@vm_base;
          color: #FFFFFF;
          .bb_bcd_title{
            font-size: 42*@vm_base;
            font-weight: 600;
            height: 86*@vm_base;
            line-height: 86*@vm_base;
            div{
              height: 86*@vm_base;
              line-height: 86*@vm_base;
              float: right;
              font-size: 28*@vm_base;
            }
          }
          .bb_bcd_cont1{
            margin-top: 70*@vm_base;
            height: 56*@vm_base;
            line-height: 56*@vm_base;
            font-size: 28*@vm_base;
            font-weight: 400;
            color:rgba(255,255,255,0.5);
            div{
              height: 40*@vm_base;
              line-height: 40*@vm_base;
              float: right;
              font-size: 28*@vm_base;
            }
          }
          .bb_bcd_cont2{
            height: 56*@vm_base;
            line-height: 56*@vm_base;
            font-size: 28*@vm_base;
            font-weight: 400;
            color:rgba(255,255,255,0.5);
            div{
              height: 40*@vm_base;
              line-height: 40*@vm_base;
              float: right;
              font-size: 28*@vm_base;
            }
          }
        }
      }
      .bb_buycardvip_bg_tip{
        padding: 48*@vm_base 0*@vm_base 60*@vm_base 0*@vm_base;
        color: #444054;
        font-size:32*@vm_base;
        font-weight:500;
        color:rgba(68,64,84,1);
        line-height:48*@vm_base;
      }
      .bb_buycardvip_bg_btn{
        width: 100%;
        .bb_buycardvip_bg_btn_left{
          width:300*@vm_base;
          height:80*@vm_base;
          line-height: 80*@vm_base;
          background:rgba(68,64,84,1);
          border-radius:12*@vm_base;
          color: #FFFFFF;
          font-size:32*@vm_base;
          text-align: center;
          font-weight:500;
          float: left;
        }
        .bb_buycardvip_bg_btn_right{
          width:300*@vm_base;
          height:80*@vm_base;
          line-height: 80*@vm_base;
          background:rgba(242,242,242,1);
          border-radius:12*@vm_base;
          font-size:32*@vm_base;
          font-weight:500;
          text-align: center;
          color:rgba(68,64,84,1);
          float: right;
        }
      }
    }

  }
</style>



// WEBPACK FOOTER //
// src/components/activate/activatesuccess.vue